// extracted by mini-css-extract-plugin
export default {"title":"About1_title__zuE3R","image":"About1_image__jZxAo","headingContainer":"About1_headingContainer__Ak-sj","smallLine":"About1_smallLine__3Vt5m","dot":"About1_dot__+W3fn"};